'use strict';
import angular from 'angular';

angular.module('app.services')
    .factory('PageNumberService', function() {
        var service = {};
        service.pages = [];

        service.setPages = function(pageArray) {
            service.pages = pageArray;
        };

        return service;
    });
